import { z } from 'zod/mini';
import { OrderLineRuleSchema, OrderLineSchema } from '~/validation/api/packageSessionResponse';
import OptionRuleInterface from './optionRuleInterface';

/*
 * If the source options are not selected (quantity <= 0):
 * - Set forced to false
 * Else
 * - Set quantity to the source quantity
 * - Set forced to true
 */
class AlwaysTogether implements OptionRuleInterface {
  // eslint-disable-next-line class-methods-use-this
  apply(
    orderLines: z.infer<typeof OrderLineSchema>[],
    sourceOrderLines: z.infer<typeof OrderLineSchema>[],
    targetOrderLines: z.infer<typeof OrderLineSchema>[],
    _rule: z.infer<typeof OrderLineRuleSchema>,
    pax: number,
  ) {
    return orderLines.map((orderLine) => {
      const orderLineClone = { ...orderLine };

      const isTargetOrderLine = targetOrderLines
        .some((targetOrderLine) => targetOrderLine.id === orderLine.id);

      if (!isTargetOrderLine) {
        return orderLineClone;
      }

      const hasSelectedSourceOrderLine = sourceOrderLines
        .some((sourceOrderLine) => sourceOrderLine.quantities.some((quantity) => quantity > 0));

      if (!hasSelectedSourceOrderLine) {
        orderLineClone.quantities = Array(pax).fill(0);
        orderLineClone.forced = false;
        return orderLineClone;
      }

      orderLineClone.quantities = Array(pax).fill(1);
      orderLineClone.forced = true;

      return orderLineClone;
    });
  }
}

export default AlwaysTogether;
